import React from 'react';
import {noop} from 'lodash';

import {asClassComponent} from '/util/hoc.util';

import {PopupContext} from './PopupProvider';

const withPopup = () => Component =>
  asClassComponent(componentProps => (
    <PopupContext.Consumer>
      {({showPopup, hidePopup}) => (
        <Component
          {...componentProps}
          showPopup={showPopup}
          hidePopup={hidePopup}
        />
      )}
    </PopupContext.Consumer>
  ));

withPopup.showPopupDefaultProp = (_Component, _props) => {};

withPopup.hidePopupDefaultProp = noop;

export default withPopup;
